import Vue from 'vue'
import App from './App.vue'
import router from "./router/index"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@wangeditor/editor/dist/css/style.css'

import 'default-passive-events'
import "./util/axios"
import axios from "axios"

Vue.prototype.$axios = axios

Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  // el: '#app',
  router,
  render: h => h(App),
}).$mount('#app')
